/**
 * Map pin (x, y) positions in px, matching Map/style.js --translate3d values.
 * Used to sort pins for tab/focus order so keyboard order follows visual layout
 * (left-to-right, then top-to-bottom).
 */
export const MAP_PIN_POSITIONS = {
  'brianna': { x: 419, y: 270 },
  'ilusha': { x: 915, y: 273 },
  'soul-science-lab': { x: 450, y: 285 },
  'qian-yi': { x: 1193, y: 288 },
  'magda': { x: 842, y: 296 },
  'zulal': { x: 938, y: 296 },
  'lily': { x: 882, y: 299 },
  'imani': { x: 309, y: 300 },
  'michael': { x: 390, y: 300 },
  'starr': { x: 255, y: 310 },
  'julia': { x: 800, y: 310 },
  'quiana': { x: 388, y: 327 },
  'layth': { x: 935, y: 330 },
  'martha': { x: 353, y: 334 },
  'kalani': { x: 80, y: 340 },
  'farah': { x: 900, y: 340 },
  'mehram': { x: 1001, y: 349 },
  'juan-julia': { x: 460, y: 370 },
  'vanAnh': { x: 1220, y: 375 },
  'emeline': { x: 405, y: 380 },
  'villalobos-brothers': { x: 280, y: 390 },
  'yasser': { x: 430, y: 390 },
  'falu': { x: 1100, y: 399 },
  'yacouba': { x: 736, y: 403 },
  'etienne': { x: 465, y: 435 },
  'makobi': { x: 910, y: 470 },
  'gregorio': { x: 410, y: 481 },
  'fabiana': { x: 536, y: 531 },
  'tanyaradzwa': { x: 879, y: 559 },
  'bongi-tshidi': { x: 849, y: 620 },
  'claudia': { x: 420, y: 650 },
  'sofia-sofia': { x: 465, y: 655 },
};
